// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "loader-2Z-WC";
var _3 = "planeSpinner-2PyOq";
var _4 = "wrapper-d3Nf8";
export { _1 as "__esModule", _2 as "loader", _3 as "planeSpinner", _4 as "wrapper" }
export default { "__esModule": _1, "loader": _2, "planeSpinner": _3, "wrapper": _4 }
